module.exports = __webpack_public_path__ + "static/image/font/pc/bmeuljiro-3@3x.ver2_0_2.jpg?665e6b03";